<template>
  <b-row>
    <b-col v-if="form.display">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }" slim>
        <b-form @submit.prevent="handleSubmit(registerKid)">
          <b-row>
            <b-col v-if="form.display" cols="12">
              <b-row>
                <b-col>
                  <h2 class="h5">
                    {{ $t('event_anmeldung.label_teilnehmendes_kind') }}
                  </h2>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_vorname') + ' *'" label-for="kidFirstName">
                    <b-form-input id="kidFirstName" size="sm" v-model="kid.firstName" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_nachname') + ' *'" label-for="kidLastName">
                    <b-form-input id="kidLastName" size="sm" v-model="kid.lastName" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_jahrgang') + ' *'" label-for="kidAgeGroup">
                    <b-form-input id="kidAgeGroup" size="sm" v-model="kid.ageGroup" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="!form.addressLine1">
                <b-col>
                  <ValidationProvider
                    :name="$t('event_anmeldung.label_adresse')"
                    :rules="{required: true}"
                    v-slot="validationContext">
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_adresse') + ' *'" label-for="addressLine1">
                    <b-form-input id="addressLine1" size="sm" v-model="kid.addressLine1" :state="getValidationState(validationContext)" aria-describedby="feedback-addressLine1"></b-form-input>
                    <b-form-invalid-feedback id="feedback-addressLine1">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="!form.zip">
                <b-col>
                  <ValidationProvider
                    :name="$t('event_anmeldung.label_plz')"
                    :rules="{required: true}"
                    v-slot="validationContext"
                  >
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_plz') + ' *'" label-for="zip">
                    <b-form-input id="zip" size="sm" v-model="kid.zip" :state="getValidationState(validationContext)" aria-describedby="feedback-plz"></b-form-input>
                    <b-form-invalid-feedback id="feedback-plz">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="!form.city">
                <b-col>
                  <ValidationProvider
                      :name="$t('event_anmeldung.label_ort')"
                      :rules="{required: true}"
                      v-slot="validationContext"
                  >
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_ort') + ' *'" label-for="city">
                    <b-form-input id="city" size="sm" v-model="kid.city" :state="getValidationState(validationContext)" aria-describedby="feedback-plz"></b-form-input>
                    <b-form-invalid-feedback id="feedback-city">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="!kid.languageLic">
                <b-col>
                  <ValidationProvider
                    :name="$t('event_anmeldung.label_sprache')"
                    :rules="{required: true}"
                    v-slot="validationContext"
                  >
                  <b-form-group
                  label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md"
                  id="fieldset-language"
                  :label="$t('event_anmeldung.label_sprache') + ' *'"
                  label-for="input-language"
                >
                  <b-form-select
                    id="input-language"
                    v-model="form.language"
                    :options="formSelect.languages"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-language"
                    size="sm"
                    class="mt-1"
                  ></b-form-select>
                  <b-form-invalid-feedback id="feedback-language">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
                </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="editKidMemberNumberSat">
                <b-col>
                  <ValidationProvider
                    :name="$t('event_anmeldung.label_lizenznummer')"
                    rules=""
                    v-slot="validationContext"
                    vid="memberNumberSat"
                  >
                    <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_lizenznummer')" label-for="kidmemberNumberSat">
                      <b-form-input id="kidMemberNumberSat" size="sm" v-model="form.memberNumberSat" :state="getValidationState(validationContext)" aria-describedby="feedback-memberNumberSat"></b-form-input>
                      <b-form-invalid-feedback id="feedback-memberNumberSat">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="!editKidMemberNumberSat">
                <b-col>
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_lizenznummer')" label-for="kidMemberNumberSat">
                    <b-form-input id="kidMemberNumberSat" size="sm" :value="kid.memberNumberSat" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_verein_schule')" label-for="kidClub">
                    <vue-typeahead-bootstrap v-model="form.club" id="kidClub" size="sm" :showAllResults="true" :ieCloseFix="false" :data="vereine" @input="clubSelected" >
                    </vue-typeahead-bootstrap>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.club !== kid.club">
                <b-col cols="12" sm="8" md="9" lg="10" class="ml-auto">
                  <b-alert class="text-center" variant="warning" show>
                    <p class="font-weight-bold">{{ $t('event_anmeldung.label_qualifikations_kanton_korrekt_z1') }}</p>
                    <p v-html="$t('event_anmeldung.label_qualifikations_kanton_korrekt_z2')"></p>
                    <p v-html="$t('event_anmeldung.label_qualifikations_kanton_korrekt_z3')"></p>
                    <p v-html="$t('event_anmeldung.label_qualifikations_kanton_korrekt_z4')" class="mb-0 font-weight-bold"></p>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_qualifikations_kanton') + ' *'" label-for="kidQualificationCantonLic">
                    <b-form-input id="kidQualificationCantonLic" size="sm" v-model="kid.qualificationCantonLicClear" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="editEmail && kid.emailSprint">
                <b-col>
                  <ValidationProvider
                    :name="$t('event_anmeldung.label_aktuelle_email')"
                    :rules="{email: true, required: true}"
                    v-slot="validationContext"
                    vid="emailcurrent"
                  >
                    <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_aktuelle_email') + ' *'" label-for="kidemailcurrent">
                      <b-form-input id="kidemailcurrent" size="sm" v-model="form.emailcurrent" :state="getValidationState(validationContext)" aria-describedby="feedback-emailcurrent"></b-form-input>
                      <b-form-invalid-feedback id="feedback-emailcurrent">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="editEmail">
                <b-col>
                  <ValidationProvider
                    :name="$t('event_anmeldung.label_neue_email')"
                    :rules="{email: true, required: true}"
                    v-slot="validationContext"
                  >
                    <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_neue_email') + ' *'" label-for="kidemail">
                      <b-form-input id="kidemail" size="sm" v-model="form.email" :state="getValidationState(validationContext)" aria-describedby="feedback-email"></b-form-input>
                      <b-form-invalid-feedback id="feedback-email">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="editEmail">
                <b-col>
                  <ValidationProvider
                    :name="$t('event_anmeldung.label_email_type')"
                    :rules="{required: true}"
                    v-slot="validationContext"
                  >
                    <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_email_type') + ' *'" label-for="kidEmailType" :class="{'mb-0': kid.emailSprint}">
                      <b-form-select id="kidEmailType" size="sm" v-model="form.emailType" :options="formSelect.emailType" :state="getValidationState(validationContext)" aria-describedby="feedback-kidEmailType"></b-form-select>
                      <b-form-invalid-feedback id="feedback-kidEmailType">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row v-if="!editEmail">
                <b-col>
                  <b-form-group label-class="font-weight-bold" label-cols="12" label-cols-sm="4" label-cols-md="3" label-cols-lg="2" label-size="md" :label="$t('event_anmeldung.label_email') + ' *'" label-for="kidemail" :class="{'mb-0': kid.emailSprint}">
                    <b-form-input id="kidemail" size="sm" :value="maskEmail(kid.emailSprint)" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mb-3" v-if="kid.emailSprint">
                <b-col sm="8" md="9" lg="10" class="ml-auto">
                  <p v-html="editEmailButtonText"></p>
                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="form.display" cols="12">
              <b-row>
                <b-col>
                  <b-form-checkbox
                    id="input-agbAccepted"
                    v-model="form.agbAccepted"
                    :value="true"
                    :unchecked-value="false"
                    class="mb-3"
                    @change="form.agbAccepted === true ? customError.agbAccepted.display = false : customError.agbAccepted.display = false"
                  >
                    <span v-html="$t('event_anmeldung.text_terms')"></span>
                    <small v-if="customError.agbAccepted.display" class="d-block text-danger">{{ customError.agbAccepted.message }}</small>
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    id="input-receivePartnerOffers"
                    v-model="form.receivePartnerOffers"
                    :value="true"
                    :unchecked-value="false"
                    class="mb-3"
                  >
                    {{ $t('event_anmeldung.text_partner_angebote') }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row v-if="formFeedback.display">
                <b-col>
                  <b-alert :variant="formFeedback.type" show>
                    {{ formFeedback.message }}
                  </b-alert>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" md="4" lg="3" class="ml-auto">
                  <b-button type="submit" block :disabled="isSubmitting">
                    <b-spinner v-if="isSubmitting" small class="mr-2"></b-spinner>
                    {{ $t('event_anmeldung.label_anmeldung_abschliessen') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
    </b-col>
    <b-col v-if="feedback.display">
      <b-row>
        <b-col :class="`text-center text-${feedback.type}`">
          <h1>{{ feedback.title }}</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <p>{{ feedback.message }}</p>
        </b-col>
      </b-row>
      <b-row v-if="feedback.displayBtns">
        <b-col class="text-center mb-3 mx-auto" style="max-width: 300px">
          <b-button @click="$emit('reset')" variant="primary" block>
            {{ $t('event_anmeldung.label_weiteres_kind_anmelden') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="feedback.displayBtns">
        <b-col class="text-center mx-auto" style="max-width: 300px">
          <b-button :to="`/${$i18n.locale}/veranstaltungen`" variant="light" block>
            {{ $t('event_anmeldung.label_zurück_zur_veranstaltungssuche') }}
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

export default {
  components: {
    VueTypeaheadBootstrap
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        display: true,
        memberNumberSat: null,
        club: null,
        emailcurrent: null,
        email: null,
        emailType: null,
        agbAccepted: false,
        receivePartnerOffers: false,
        addressLine1: null,
        zip: null,
        city: null,
        language: null,
      },
      formSelect: {
        emailType: [],
        languages: [],
      },
      formFeedback: {
        display: false,
        message: '',
        type: 'info',
      },
      feedback: {
        display: false,
        type: '',
        title: '',
        message: '',
        displayBtns: true,
      },
      editEmail: false,
      editEmailButtonText: this.$t('event_anmeldung.label_email_aktualisieren'),
      editKidMemberNumberSat: false,
      customError: {
        agbAccepted: {
          display: false,
          message: null,
        }
      },
      vereine: '',
      //TODO: move to seperate File
      vereinListe: ['TV Stein (AG)','TV Zofingen LA','SATUS Rothrist LA','BTV Aarau Athletics','TV Buchs AG','LV Fricktal','LAR TV Windisch','Laufsportgruppe Brugg','Vom Stein Baden','TV Wohlen AG','LA Villmergen','STV Beinwil/Freiamt','STV Auw','SATUS Gränichen','STV Gränichen LA','STV Mühlau','LV Wettingen-Baden','LA Mutschellen','Lauf-Team Lenzburg','FSG La Neuveville','CA Courtelary','CA Moutier','GG Bern','STB Leichtathletik','TV Länggasse Bern','LAG TV Zollikofen','TV Bolligen','TV Ostermundigen','TV Schwarzenburg','TV Oberwangen','TSV Frauenkappelen','LAC Wohlen','TV Lyss','TV Fraubrunnen','TV Herzogenbuchsee','LA Rüegsauschachen','LC Kirchberg','STV Sumiswald','TV Grosshöchstetten','TV Konolfingen Athletics','SK Langnau','LV Thun','TV Spiez','LC Scharnachtal','TV Saanen-Gstaad','TV Unterseen','TV Meiringen','LV Langenthal','LV Huttwil','TV Attiswil','Satus Biel-Bienne','TV Oberdiessbach','Fun and Run Thun','TV Aarberg Leichtathletik','Gerbersport','Biel/Bienne Athletics','TV Lützelflüh Athletics','FSG St-Imier','TVM Buchsi-Athletics','TSV Vechigen','FSG Féminine Tavannes','TIP-TOP Swiss Polysport','Turn- und Sportverein Wangen an der Aare','Laufteam Emmental','Turnverein Kehrsatz','LAS Old Boys Basel','LC Basel','LAR Binningen','Sportclub Biel-Benken','LC Therwil','TV Riehen','TV Muttenz athletics','TV Arlesheim','SC Liestal','LG Oberbaselbiet / BTV Sissach','Blind-Jogging','Basel Running Club Athletics','LV FrenkeFortuna','Verein Kinder-Camps','FSG Estavayer','SA Bulle','CS Marsens','CS Neirivue','CARC Romont','CA Fribourg','Athletic Team Rechthalten','TSV Heitenried','Sportverein Alterswil','CA Marly','CS Le Mouret','CA Gibloux Farvagny','CA Belfaux','CA Rosé','TV Bösingen','TSV Wünnewil','TSV Düdingen','TSV Gurmels','AC Murten','TV Plaffeien','Athletica Veveyse','TSV St. Antoni','Cottens Athlètes','Athlétisme Viseu-Genève','CA Genève','CHP Genève','Stade Genève','FSG Meyrin','C.H. Châtelaine','SATUS Athl. Genève','FSG Bernex-Confignon','FSG Versoix','Versoix Athlétisme','Perform-CBS','Athletic Club 3-Chêne','InVia Run','Florimont-Athletic Club','LAV Glarus','BTV Chur Leichtathletik','AJ TV Landquart','TV Thusis','TV Tamins','LC Luzern','TV Reussbühl LA','LC Emmenstrand','TSV Rothenburg athletics','TV Inwil','LR Ebikon','Leichtathletik-Vereinigung Horw','TV Sarnen LA','STV Malters','TV Wolhusen','STV Willisau','LR Gettnau','STV Altbüron','TSV Oberkirch','TV Sursee','STV Beromünster','STV Roggliswil','STV Ballwil','AUDACIA Hochdorf Leichtathletik','LAR STV Hitzkirch','LK Zug','Hochwacht Zug','TV Cham 1884','STV Oberägeri','TSV 2001 Rotkreuz','LA Nidwalden','LC Altdorf','Leichtathletik Kerns','STV Sempach','TV Grosswangen','TV Bürglen','Team FitSport.ch','Laufgruppe Cham Track','LR Nottwil','LGV 2015 Zug','Leichtathletik Alpnach','Athletikzentrum Sarnen-Unterwalden','ESV Eschenbach','STV Unterägeri','GS Franches-Montagnes','Delémont Athlétisme','FSG Courroux','Fémina Vicques','FSG Bassecourt','FSG Alle','CA Fontenais','FSG Courgenay','CA des Franches-Montagnes','CEP Cortaillod','FSG Bevaix','FSG Corcelles-Cormondrèche','FSG Couvet','FSG Geneveys et Coffrane','SEP Olympic La Chaux-de-Fonds','FSG Le Locle','FSG Cernier','LAG Gossau','LC Rapperswil-Jona','STV Eschenbach SG','TV Mels','LA Speicher','LR TV Appenzell','TV Teufen','TV Herisau','TV Lütisburg','LGB Bodensee','TV Thal','STV Au SG','TV Widnau','Athleticteam KTV Altstätten','STV Balgach','KTV Oberriet','STV Oberriet-Eichenwies','STV Gams','LC Vaduz','TV Eschen-Mauren','LC Schaan','TV Schaan / Leichtathletik','Turnverein Triesen','KTV Wil LA','KTV Bütschwil','LC Brühl Leichtathletik','LGB Benken','TV St. Peterzell','STV Grabs','LA Sennwald','STV Kriessern','TSV Engelburg','STV St. Margrethen','TSV Fortitudo Gossau','TV St. Gallen-Ost','STV Ganterschwil','TV Schänis','TV Azmoos','SVD athletics','STV Marbach SG','TSV Hinterforst','Turnverein Bad Ragaz','LC Schaffhausen','PLUSPORT Behindertensport Schweiz','TV Grenchen','Biberist aktiv! Leichtathletik','STV Bettlach','TV Selzach','Laufental Thierstein Athletics','TV Biezwil','LA-Riege TV Olten','STV Gunzgen','LA TV Wolfwil','LZ Lostorf','TSV Kestenholz','STV Welschenrohr','TV Gretzenbach','TSV Mümliswil-Ramiswil','STV Oensingen','Leichtathletikclub Oensingen','STV Hägendorf','STV Küssnacht','TSV Steinen','TV Ibach','TV Brunnen','STV Gersau','KTV Freienbach','STV Pfäffikon-Freienbach','STV Wollerau-Bäch','ETV Schindellegi','STV Einsiedeln','KTV Altendorf','Turnverein Siebnen','TSV Galgenen','STV Wangen SZ','STV Lachen','STV Tuggen','STV Wägital','TV Buttikon-Schübelbach','Leichtathletik Arth','LAR Tägerwilen-Kreuzlingen','TSV Guntershausen','KTV Frauenfeld','STV Berg','LAR Bischofszell','STV Güttingen','LC Bottighofen','STV Neukirch-Egnach','LC Frauenfeld','TV Eschlikon','Amriswil-Athletics','GAB Bellinzona','SA Bellinzona','Atletica Tenero 90','Vis Nova Agarone','SAG Gordola','VIRTUS Locarno','US Ascona atletica','SFG Biasca','SFG Airolo','ASSPO Riva San Vitale','Atletica Mendrisiotto','SFG Chiasso','SAV Vacallo','SVAM Muggio','SFG Mendrisio','VIGOR Ligornetto','SAM Massagno','SAL Lugano','USC Capriaschese-Atletica','GAD Dongio','Unitas Malcantone','FG Malcantone','AS Monteceneri',"Runner's Club Bellinzona",
'Stade Lausanne Athlétisme','Lausanne-Sports Athlétisme','CM Cour Lausanne','FSG Saint-Cierges','FSG Epalinges','COVA Nyon','US Yverdon','CA Broyard','FSG Avenches','CA Riviera','FSG Morges','Ecole nouvelle de la Suisse Romande','FSG La Sarraz','Running Team Prilly','Gym Rolle','Croc-Kil...Leysin','ATLET(Association Team Léman Espoirs Triathlon)','Société de gymnastique de Moudon','Société de Gymnastique de Saint-Prex','FSG Chexbres','FSG Penthalaz','ATHLE.ch','Amis-Gym Forel-Savigny','FSG Orbe-Ancienne','FSG Grandson','AthleTEAM Lutry','Club de Marche de Monthey','SG St-Maurice','SFG Collombey-Muraz','CABV Martigny','CS 13 Etoiles','SFG Conthey','CA Sion','CA Vétroz','ES Ayent Anzère','LLT Oberwallis','TV Naters','LV Visp','STV Gampel','CA Sierre DSG','T-R-T Athlétisme Monthey','CA Dents-du-Midi','Académie Trail Running Valais','Termen athletics','CC Running Saxon','TV Hausen a.A.','LAC TV Unterstrass','STV Wiedikon','LC Zürich','TV Altstetten-Zürich','SATUS Zürich-Oerlikon','LC Regensdorf','TV Egg','Adliswil Track Team','LC Turicum','TV Kloten LA','TV Dietlikon','LV Winterthur','TV NS Winterthur','TV Kilchberg','Leichtathletik-Club Dübendorf','LC Uster','TV Uster','TV Oerlikon','LV Zürcher Oberland','LAR TV Rüti','TV Hombrechtikon','LC Meilen','TV Thalwil','TV Horgen','TV Wädenswil','LV Albis','TV Maur','LA Wyland','TG Hütten','LGKE Küsnacht-Erlenbach','TV Otelfingen','LC Rafzerfeld','TV Dägerlen','SSC Athletics','Turnverein Wiesendangen','STV Höri','LC Furttal ZH-Nord','TV Richterswil',],
    }
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    kid: {
      type: Object,
      required: true
    }
  },
  created() {
    this.getEmailTypeList();
    this.getLanguage();
    // Setup boolean flags: show fields if API returns false
    this.form.addressLine1 = this.kid.addressLine1;
    this.form.zip = this.kid.zip;
    this.form.city = this.kid.city;

    this.kid.addressLine1 = this.kid.addressLine1 === false ? '' : this.kid.addressLine1;
    this.kid.zip = this.kid.zip === false ? '' : this.kid.zip;
    this.kid.city = this.kid.city === false ? '' : this.kid.city;

    this.form.club = this.kid.club;
    this.form.language = this.kid.languageLic;
    //console.log('kid: ', JSON.stringify(this.kid));
    // Translate LIC values
    this.kid.qualificationCantonLicClear = this.$t(this.kid.qualificationCantonLic);

    // Setup, if the email field is editable or if the button to toggle editfield is displayed
    this.editEmail = this.kid.emailSprint === '' || this.kid.emailSprint === null || this.kid.emailSprint === undefined;

    // Setup, if the kidMemberNumberSat field is editable or if the button to toggle editfield is displayed
    this.editKidMemberNumberSat = this.kid.memberNumberSat === '' || this.kid.memberNumberSat === null || this.kid.memberNumberSat === undefined;
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    mapLov(arr) {
      return arr.map((obj) => {
        var rObj = { value: "", text: "" };
        rObj.value = obj.lic;
        rObj.text = this.$t(obj.lic);
        return rObj;
      });
    },
    toggleEditMail() {
      if (this.editEmail) {
        // Reset email form fields
        this.form.emailcurrent = null;
        this.form.email = null;
        this.form.emailType = null;

        // Hide email edit
        this.editEmail = false;
        this.editEmailButtonText = this.$t('event_anmeldung.label_email_aktualisieren');
      } else {
        // Show email edit
        this.editEmail = true;
        this.editEmailButtonText = this.$t('event_anmeldung.label_email_aktualisieren_abbrechen');
      }
    },
    getEmailTypeList() {
      this.$store
        .dispatch("lov/getEmailType")
        .then((resp) => {
          this.formSelect.emailType = this.mapLov(resp.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    registerKid() {
      this.resetFeedbackMessages();
      this.isSubmitting = true;

      try {

        // Prüfe, ob die aktuelle E-Mail korrekt angegeben wurde (breche anmeldung ab, falls nicht)
        if (this.editEmail && this.kid.emailSprint && (this.form.emailcurrent != this.kid.emailSprint)) {
          this.$refs.observer.setErrors({
            emailcurrent: [this.$t('event_anmeldung.error_email_stimmt_nicht_überein')]
          });
          this.isSubmitting = false;
          return;
        }

        // Prüfe ob Teilnahmebedingungen akzeptiert wurden (breche anmeldung ab, falls nicht)
        if (this.form.agbAccepted === false) {
          this.customError.agbAccepted.message = this.$t('event_anmeldung.error_terms_not_accepted');
          this.customError.agbAccepted.display = true;
          this.isSubmitting = false;
          return;
        }

        const data = {
          nwpId: this.event.id, // Id des Wettkampfes
          satMemberNumber: this.form.memberNumberSat !== null ? this.form.memberNumberSat : this.kid.memberNumberSat, // Swiss Athletics Lizenznummer
          kidId: this.kid.kidId, // Kid Id
          firstName: String(this.kid.firstName).trim(), // Vorname
          lastName: String(this.kid.lastName).trim(), // Nachname
          ageGroup: this.kid.ageGroup, // Jahrgang
          sex: this.kid.sexLic, // Geschlecht
          addressLine1: this.kid.addressLine1 ?? '', // Adresse
          zip: this.kid.zip ?? '', // PLZ
          city: this.kid.city ?? '', // Ort
          canton: this.kid.cantonLic, // Kanton
          club: this.form.club, // Verein
          email: this.form.email !== null ? this.form.email : this.kid.emailSprint, // E-Mail
          emailType: this.form.emailType !== null ? this.form.emailType : this.kid.emailTypeLicSprint, // E-Mail Typ
          language: this.form.language, // Sprache
          agbAccepted: this.form.agbAccepted, // AGB / Teilnahebedingungen akzeptiert
          receivePartnerOffers: this.form.receivePartnerOffers, // Informationen über Partnerangebote sind erlaubt
        };

        // Sende formular daten an api
        this.$store
          .dispatch("wettkampf/setTeilnehmer", data)
          .then(() => {
            this.form.display = false;

            this.feedback.type = 'success';
            this.feedback.title = this.$t('event_anmeldung.text_anmeldung_erfolgreich');
            this.feedback.message = this.$t('event_anmeldung.text_anmeldung_email_benachrichtigung');
            this.feedback.displayBtns = true;
            this.feedback.display = true;
          })
          .catch((err) => {
            var severity = '';
            var errorCode = '';
            var debugMessage = '';
            var userFriendlyMessage = '';
            var lic = '';

            try {
              severity = err.response.data.severity;
              errorCode = err.response.data.errorCode;
              debugMessage = err.response.data.debugMessage;
              userFriendlyMessage = err.response.data.userFriendlyMessage;
              lic = err.response.data.lic;
            } catch (error) {
              severity = '';
              errorCode = '';
              debugMessage = '';
              userFriendlyMessage = '';
              lic = '';
            }

            if (errorCode == 'NAMESDONTMATCH' && userFriendlyMessage) {
              this.$refs.observer.setErrors({
                memberNumberSat: [`${this.$t('event_anmeldung.error_license_not_matching')} - ${userFriendlyMessage}.`]
              });
              return;
            } else if (errorCode == 'YEAROFBIRTHDONTMATCH' && userFriendlyMessage) {
              this.$refs.observer.setErrors({
                memberNumberSat: [`${this.$t('event_anmeldung.error_license_not_matching')} - ${userFriendlyMessage}.`]
              });
              return;
            } else if (errorCode == 'NOCONTACTFOUNDFORSATMEMBERNUMBER' && userFriendlyMessage) {
              this.$refs.observer.setErrors({
                memberNumberSat: [`${this.$t('event_anmeldung.error_license_not_matching')} - ${this.$t('event_anmeldung.error_license_no_matching_person')}`]
              });
              return;
            } else if (debugMessage.includes('satMemberNumber')) {
              this.$refs.observer.setErrors({
                memberNumberSat: [`${this.$t('event_anmeldung.error_license_not_matching')} - ${this.$t('event_anmeldung.text_try_again_later')}`]
              });
              return;
            } else {
              // Do nothing
            }

            if (this.formFeedback.message) {
              this.formFeedback.type = 'danger';
              this.formFeedback.display = true;
              this.displayPageLoader = false;
              return
            }

            this.form.display = false;

            try {
              this.feedback.message = errorCode == 'KIDALREADYREGISTEREDEVENT' ? this.$t('event_anmeldung.error_kid_already_registered') : (userFriendlyMessage ? userFriendlyMessage : `${this.$t('event_anmeldung.error_something_went_wrong')} - ${this.$t('event_anmeldung.text_try_again_later')}`);
            } catch (error) {
              this.feedback.message = `${this.$t('event_anmeldung.error_something_went_wrong')} - ${this.$t('event_anmeldung.text_try_again_later')}`;
            }

            this.feedback.type = 'danger';
            this.feedback.title = this.$t('event_anmeldung.text_anmeldung_fehlgeschlagen');
            this.feedback.displayBtns = false;
            this.feedback.display = true;
          })
          .then(() => {
            this.isSubmitting = false;
          });
      } catch (error) {
        console.log('error in registerKid()', error);
      }
    },
    maskEmail(email) {
      try {
        if (email === '' || email === null || email === undefined) return '';
        return email.substr(0,2) + '***@***' + email.substr(email.lastIndexOf(".") - 1);
      } catch (error) {
        return '';
      }
    },
    resetFeedbackMessages() {
      this.formFeedback.display = false;
      this.formFeedback.message = '';
      this.formFeedback.type = 'info';

      this.feedback.display = false;
      this.feedback.type = '';
      this.feedback.title = '';
      this.feedback.message = '';
      this.feedback.displayBtns = true;
    },
    clubSelected() {
      const searchTerm = this.form.club.toLowerCase();
      this.vereine = this.vereinListe.filter(vereine => vereine.toLowerCase().includes(searchTerm));
    },
    getLanguage() {
      this.$store
        .dispatch("lov/getLanguage")
        .then((resp) => {
          this.formSelect.languages = this.mapLov(resp.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
}
</script>